export namespace ItineraryConstants {
  export interface DayOfTheWeek {
    name: string;
    abbreviation: string;
    order: string;
  }

  export const DaysOfTheWeek: { [key: string]: { name: string; abbreviation: string; order: number } } = {
    SUNDAY: {
      name: 'Sunday',
      abbreviation: 'Sun',
      order: 0
    },
    MONDAY: {
      name: 'Monday',
      abbreviation: 'Mon',
      order: 1
    },
    TUESDAY: {
      name: 'Tuesday',
      abbreviation: 'Tue',
      order: 2
    },
    WEDNESDAY: {
      name: 'Wednesday',
      abbreviation: 'Wed',
      order: 3
    },
    THURSDAY: {
      name: 'Thursday',
      abbreviation: 'Thu',
      order: 4
    },
    FRIDAY: {
      name: 'Friday',
      abbreviation: 'Fri',
      order: 5
    },
    SATURDAY: {
      name: 'Saturday',
      abbreviation: 'Sat',
      order: 6
    }
  };

  export function daysOfTheWeekArray(): Array<DayOfTheWeek> {
    const daysOfTheWeekArray = [];

    Object.values(DaysOfTheWeek).forEach(value => {
      daysOfTheWeekArray.push(value);
    });

    daysOfTheWeekArray.sort((a, b) => a.order - b.order);

    return daysOfTheWeekArray;
  }
}
